const translations = {
    year_index: "Yıllar Modülü - Görüntüleme",
    year_store: "Yıllar Modülü - Ekleme",
}

export default translations


